const img = {
  nasiKerabu: 'https://images.unsplash.com/photo-1677921755291-c39158477b8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxtYWxheXNpYW4lMjBmb29kJTIwbmFzaSUyMGtlcmFidXxlbnwwfHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  nasiAyam: 'https://images.unsplash.com/photo-1569058242252-623df46b5025?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxtYWxheXNpYW4lMjBmb29kJTIwbmFzaSUyMGtlcmFidXxlbnwwfHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  foodPlate: 'https://images.unsplash.com/photo-1666239308345-c4c12ef3e177?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxtYWxheXNpYW4lMjBmb29kJTIwbmFzaSUyMGtlcmFidXxlbnwwfHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  batik1: 'https://images.unsplash.com/photo-1761515315375-1315503bb3ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxiYXRpayUyMGZhYnJpYyUyMHRleHRpbGUlMjBwYXR0ZXJufGVufDB8fHx8MTc4ODE1MDUwNHww&ixlib=rb-4.1.0&q=85',
  batik2: 'https://images.unsplash.com/photo-1762111908858-201b9da429dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxiYXRpayUyMGZhYnJpYyUyMHRleHRpbGUlMjBwYXR0ZXJufGVufDB8fHx8MTc4ODE1MDUwNHww&ixlib=rb-4.1.0&q=85',
  batik3: 'https://images.unsplash.com/photo-1761516659497-8478e39d2b26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxiYXRpayUyMGZhYnJpYyUyMHRleHRpbGUlMjBwYXR0ZXJufGVufDB8fHx8MTc4ODE1MDUwNHww&ixlib=rb-4.1.0&q=85',
  batikCraft: 'https://images.unsplash.com/photo-1711955764834-a985a19bb30f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxiYXRpayUyMGZhYnJpYyUyMG1hbGF5c2lhbnxlbnwwfHx8fDE3ODgxNTAzNTh8MA&ixlib=rb-4.1.0&q=85',
  cake1: 'https://images.unsplash.com/photo-1700448293876-07dca826c161?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjaG9jb2xhdGUlMjBjYWtlJTIwc2xpY2UlMjBkZXNzZXJ0fGVufDB8fHx8MTc4ODE1MDUwM3ww&ixlib=rb-4.1.0&q=85',
  cake2: 'https://images.unsplash.com/photo-1576618148423-df549bcb6972?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxjaG9jb2xhdGUlMjBjYWtlJTIwc2xpY2UlMjBkZXNzZXJ0fGVufDB8fHx8MTc4ODE1MDUwM3ww&ixlib=rb-4.1.0&q=85',
  cake3: 'https://images.unsplash.com/photo-1517427294546-5aa121f68e8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxjaG9jb2xhdGUlMjBjYWtlJTIwc2xpY2UlMjBkZXNzZXJ0fGVufDB8fHx8MTc4ODE1MDUwM3ww&ixlib=rb-4.1.0&q=85',
  coffee1: 'https://images.unsplash.com/photo-1513530176992-0cf39c4cbed4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxyb2FzdGVkJTIwY29mZmVlJTIwYmVhbnN8ZW58MHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  coffee2: 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxyb2FzdGVkJTIwY29mZmVlJTIwYmVhbnN8ZW58MHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  gift1: 'https://images.unsplash.com/photo-1632924192284-9163f3d88a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxoYW5kbWFkZSUyMGdpZnQlMjBib3glMjBjcmFmdHxlbnwwfHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  gift2: 'https://images.unsplash.com/photo-1639562954924-975ca13f454a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxoYW5kbWFkZSUyMGdpZnQlMjBib3glMjBjcmFmdHxlbnwwfHx8fDE3ODgxNTA1MDR8MA&ixlib=rb-4.1.0&q=85',
  camera1: 'https://images.unsplash.com/photo-1520549233664-03f65c1d1327?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxjYW1lcmElMjB3aXRoJTIwbGVhdGhlciUyMHN0cmFwfGVufDB8fHx8MTc4ODE1MDUwNHww&ixlib=rb-4.1.0&q=85',
  camera2: 'https://images.unsplash.com/photo-1516961642265-531546e84af2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxjYW1lcmElMjB3aXRoJTIwbGVhdGhlciUyMHN0cmFwfGVufDB8fHx8MTc4ODE1MDUwNHww&ixlib=rb-4.1.0&q=85',
  rider: 'https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxmb29kJTIwZGVsaXZlcnklMjByaWRlciUyMG1vdG9yY3ljbGV8ZW58MHx8fHwxNzg4MTUwMzU4fDA&ixlib=rb-4.1.0&q=85',
};
export const IMAGES = img;

export const CATEGORIES = [
  'Food & Beverage', 'Restaurant', 'Cafe', 'Bakery', 'Catering', 'Local Food',
  'Fashion', 'Beauty', 'Electronics', 'Home & Living', 'Gifts', 'Local Products',
  'Automotive', 'Education', 'Creative', 'Photography', 'Printing', 'Travel', 'Services', 'Others',
];

export const DISTRICTS = [
  'Kota Bharu', 'Pasir Mas', 'Tumpat', 'Bachok', 'Machang',
  'Tanah Merah', 'Pasir Puteh', 'Kuala Krai', 'Gua Musang', 'Jeli',
];

export const MALAYSIA_STATES = [
  'Kelantan', 'Terengganu', 'Pahang', 'Perak', 'Selangor', 'Kuala Lumpur',
  'Penang', 'Kedah', 'Perlis', 'Negeri Sembilan', 'Melaka', 'Johor', 'Sabah', 'Sarawak',
];

export const PLANS = {
  LIST: { name: 'LIST', monthly: 10, annual: 100, goal: 'Be Found', productLimit: 0, commission: 0.05, features: ['Business directory page', 'Category & address listing', 'Phone & WhatsApp', 'Opening hours & map'] },
  STORE: { name: 'STORE', monthly: 50, annual: 500, goal: 'Own a Store', productLimit: 20, commission: 0.05, features: ['Everything in LIST', 'Logo, banner & social links', 'Up to 20 products', 'Marketplace selling', 'Basic analytics', '5% commission'] },
  BOOST: { name: 'BOOST', monthly: 100, annual: 1000, goal: 'Get Traffic', productLimit: 50, commission: 0.05, features: ['Everything in STORE', 'Up to 50 products', 'Promotions & vouchers', 'Featured placement & priority', 'Social promotion credit', 'Advanced analytics', '5% commission'] },
  BRAND: { name: 'BRAND', monthly: 200, annual: 2000, goal: 'Build a Brand', productLimit: 999, commission: 0.05, features: ['Everything in BOOST', '100+ products', 'Highest priority & premium badge', 'Homepage opportunities', 'Campaign priority', '2-4 content credits', '5% commission'] },
};

export const PLAN_RANK = { BRAND: 0, BOOST: 1, STORE: 2, LIST: 3 };

export const DEFAULT_CAMPAIGN = {
  active: true,
  title: 'KELATE Food Week',
  headline: 'Taste the familiar, find the unexpected.',
  description: 'Limited local menus, festive boxes and delivery offers from Kelantan\'s trusted food makers.',
  cta: 'See Food Week',
};

export const DEFAULT_DELIVERY_SETTINGS = {
  referenceName: 'KELATE KB Hub - Simpang Empat',
  lat: 6.1254,
  lng: 102.2381,
  radiusKm: 10,
  localFee: 3,
  kelantanFee: 5,
  outsideFee: 10,
};

export const DEFAULT_HOME_LAYOUT = [
  { id: 'hero', label: 'Hero Banner', locked: true, enabled: true },
  { id: 'categories', label: 'Categories', enabled: true },
  { id: 'deals', label: "Today's Deals", enabled: true },
  { id: 'campaign', label: 'Campaign Banner', enabled: true },
  { id: 'madeInKelantan', label: 'Made in Kelantan', enabled: true },
  { id: 'nearYou', label: 'Popular Near You', enabled: true },
  { id: 'featuredStores', label: 'Featured Stores', enabled: true },
  { id: 'bestSelling', label: 'Best Selling', enabled: true },
  { id: 'newArrivals', label: 'New Arrivals', enabled: true },
  { id: 'explore', label: 'Explore Kelantan', enabled: true },
  { id: 'partners', label: 'Collaboration Partners', enabled: true },
  { id: 'merchantCta', label: 'Become a Merchant CTA', enabled: true },
];

export const VOUCHERS = [];

export const KELATE_BANK = { holder: 'K-ONEED MULTIMEDIA CLUB', bank: '', account: '3824287800' };
export const KELATE_TNG = { holder: 'K-ONEED MULTIMEDIA CLUB', number: '011-33292117' };

export function computeDeliveryFee(address, settings) {
  if (!address || address.state !== 'Kelantan') {
    return { fee: settings.outsideFee, zone: 'ZONE 3 - Outside Kelantan' };
  }
  if (address.district === 'Kota Bharu') {
    return { fee: settings.localFee, zone: 'ZONE 1 - KB Local' };
  }
  return { fee: settings.kelantanFee, zone: 'ZONE 2 - Kelantan' };
}

export function commissionFor(plan) {
  return PLANS[plan]?.commission ?? 0.05;
}

export const fmtRM = (n) => `RM${Number(n).toFixed(2).replace(/\.00$/, '')}`;
export const fmtRM2 = (n) => `RM${Number(n).toFixed(2)}`;
export const timeAgo = (iso) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};
